import {
  useTranslation,
} from 'react-i18next'
import {
  Box,
  List,
  ListItem,
  Typography,
} from '@mui/material'

import ProposalServiceLineAmounts from './proposal-service-line-amounts'
import {
  PROPOSAL_SERVICE_LINE_KINDS,
  proposalServiceLineTitleKey,
} from '../proposal-service-line-utils'

const ProposalServiceLinesDisplay = ({
  serviceLines,
  currencyCode,
  comparison,
  managerView = false,
}: ApplicationProposalServiceLinesDisplayProps) => {
  const { t } = useTranslation()
  const rowPadding = managerView ? 1 : 1.5
  const ordered = PROPOSAL_SERVICE_LINE_KINDS.map((kind) => (
    serviceLines.find((line) => line.kind === kind)
  )).filter(Boolean) as ApplicationProposalServiceLine[]

  if (!ordered.length) return null

  return (
    <List disablePadding className='application-proposal-service-lines-display'>
      {ordered.map((line, index) => (
        <ListItem
          key={line.kind}
          disableGutters
          divider={index < ordered.length - 1}
          sx={{
            paddingTop: rowPadding,
            paddingBottom: index === ordered.length - 1 ? 0 : rowPadding,
            alignItems: 'center',
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) max-content',
            gap: 2,
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              overflowWrap: 'anywhere',
            }}
          >
            <Typography variant='subtitle2'>
              {line.kind_label || t(proposalServiceLineTitleKey(line.kind))}
            </Typography>
            {line.comment?.trim() && (
              <Typography
                variant='body2'
                color={managerView ? 'text.primary' : 'text.secondary'}
                sx={{
                  whiteSpace: 'pre-wrap',
                }}
              >
                {line.comment}
              </Typography>
            )}
          </Box>
          <ProposalServiceLineAmounts
            comparison={comparison?.lines.find((row) => row.kind === line.kind) ?? {
              before: line.original_amount,
              after: line.amount,
              delta: null,
            }}
            currencyCode={currencyCode}
          />
        </ListItem>
      ))}
    </List>
  )
}

export default ProposalServiceLinesDisplay
